import { create } from "zustand";

type RegistrationFlowState = {
  firstRegistration: boolean;
  setFirstRegistration: (value: boolean) => void;
};

export const useRegistrationFlowStore = create<RegistrationFlowState>((set) => ({
  firstRegistration: false,
  setFirstRegistration: (value) => set({ firstRegistration: value }),
}));
